import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'
import { NextLoading } from '@/utils/loading/loading'
import NProgress from 'nprogress'
import store from "@/store";
import _ from 'lodash'
const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'login',
        meta: { isAuth: false },
        component: () => import(/* webpackChunkName: "login" */ '@/layout/login.vue')
    },
    {
        path: '/main',
        name: 'main',
        meta: { isAuth: false },
        redirect: '/home',
        component: () => import( /* webpackChunkName: "main" */ '@/layout/main.vue'),
        children: [
            { path: '/pageAuth', meta: { isAuth: false, perm: '' }, component: () => import( /* webpackChunkName: "pageAuth" */ '@/layout/noAuth.vue') },
            { path: '/home', meta: { isAuth: false, perm: '' }, component: () => import( /* webpackChunkName: "home" */ '@/layout/home.vue') },
            { path: '/user', meta: { isAuth: true, perm: 'organize.user.query' }, component: () => import( /* webpackChunkName: "admin" */ '@/views/admin/user/userList.vue') },
            { path: '/menu', meta: { isAuth: true, perm: 'organize.menu.query' }, component: () => import( /* webpackChunkName: "admin" */ '@/views/admin/menu/menuList.vue') },
            { path: '/role', meta: { isAuth: true, perm: 'organize.role.query' }, component: () => import( /* webpackChunkName: "admin" */ '@/views/admin/role/roleList.vue') },
            { path: '/contractList', meta: { isAuth: true, perm: 'contract.list.query' }, component: () => import( /* webpackChunkName: "contract" */ '@/views/contract/contractList/contractList.vue') },
            { path: '/msign', meta: { isAuth: true, perm: 'contract.msign.query' }, component: () => import( /* webpackChunkName: "contract" */ '@/views/contract/msign/msignList.vue') },
            { path: '/memberList', meta: { isAuth: true, perm: 'member.list.query' }, component: () => import( /* webpackChunkName: "member" */ '@/views/member/memberlist/memberList.vue') },
            { path: '/clockin', meta: { isAuth: true, perm: 'member.clockin.query' }, component: () => import( /* webpackChunkName: "member" */ '@/views/member/clockin/clockinListNew.vue') },
            { path: '/mupload', meta: { isAuth: true, perm: 'member.mupload.query' }, component: () => import( /* webpackChunkName: "member" */ '@/views/member/mupload/muploadList.vue') },
            { path: '/document', meta: { isAuth: true, perm: 'sys.document.query' }, component: () => import(/* webpackChunkName: "system" */ '@/views/system/document/document.vue') },
            { path: '/config', meta: { isAuth: true, perm: 'sys.config.query' }, component: () => import(/* webpackChunkName: "system" */ '@/views/system/mallConfig/config.vue') },
            { path: '/agree', meta: { isAuth: true, perm: 'sys.agree.query' }, component: () => import(/* webpackChunkName: "system" */ '@/views/system/agreement/agreement.vue') },
            { path: '/project', meta: { isAuth: true, perm: 'project.list.query' }, component: () => import(/* webpackChunkName: "system" */ '@/views/project/project/projectList.vue') },
            { path: '/topic', meta: { isAuth: true, perm: 'exam.topic.query' }, component: () => import(/* webpackChunkName: "system" */ '@/views/exam/topic/topicList.vue') },
            { path: '/line', meta: { isAuth: true, perm: 'project.line.query' }, component: () => import(/* webpackChunkName: "system" */ '@/views/project/line/lineList.vue') },
            { path: '/unit', meta: { isAuth: true, perm: 'project.unit.query' }, component: () => import(/* webpackChunkName: "system" */ '@/views/project/unit/unitList.vue') },
            // { path: '/authCode', meta: { isAuth: true, perm: 'sys.authCode.query' }, component: () => import(/* webpackChunkName: "system" */ '@/views/system/authCode/authCodeList.vue') },
           
        ]
    },
    {
        path: '/noAuth',
        name: 'noAuth', 
        meta: { isAuth: false },
        component: () => import('@/layout/noAuth.vue')
    },
    {
        path: '/404',
        name: '404',
        meta: { isAuth: false },
        component: () => import('@/layout/404.vue')
    },
    // 所有未定义路由，全部重定向到404页，必须放在最后
    {
        path: '/:pathMatch(.*)',
        redirect: '/404'
    }
]

const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_WEB),
    routes
})
router.beforeEach((to, from, next) => {
    let path = to.path
    let isAuth = to.meta.isAuth
    let perm: any = to.meta.perm
    if (window.nextLoading === undefined) NextLoading.start();
    NProgress.start()
    if (isAuth) {
        let menu = JSON.stringify(store.state.adminInfo.menuChildren).indexOf(path) != -1 ? true : false
        if (menu) {
            let auth = perm && JSON.stringify(store.state.adminInfo.menuAuthChildren).indexOf(perm) != -1 ? true : false
            if (auth) next()
            else next('/pageAuth');
        } else next('/noAuth');
    } else {
        next()
    }
})
router.afterEach(() => {
    NProgress.done()
    NextLoading.done()
})
export default router
